import { render } from "./birdsGrooming.vue?vue&type=template&id=026f93a9"
import script from "./birdsGrooming.vue?vue&type=script&lang=js"
export * from "./birdsGrooming.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__